import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { FormikError } from '../formik_error/FormikError'
import styles from './CheckBox.module.scss'

export const CheckBox = ({
  checked,
  onChange,
  formik,
  field,
  label,
  labelStyling = {},
  containerStyling = {},
  ariaLabel,
  square = false,
  isRequired = false,
}: any) => {
  const { t } = useTranslation()

  const handleClick = (e) => {
    e.preventDefault()
    onChange(!checked)
  }

  return (
    <div className={styles['container']}>
      <button
        style={containerStyling}
        className={styles['btn']}
        onClick={handleClick}
        aria-label={`${ariaLabel || 'Button'}: ${checked ? t('registration.selected') : t('registration.unSelected')}`}
      >
        <div
          className={clsx(styles['btn__toggle'], {
            [styles['btn__toggle--active']]: checked,
            [styles['btn__toggle--square']]: square,
          })}
        ></div>
        <span className={styles['btn__label']} style={labelStyling}>
          {label} {isRequired && <span className={styles['btn__label--required']}>*</span>}
        </span>
      </button>
      <FormikError formik={formik} fieldName={field} />
    </div>
  )
}
